// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    UpdateCartApiParameter,
    updateCartWithResult,
} from "@insite/client-framework/Services/CartService";
import ootbLoadCartHandler from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

export type UpdateCartParameter = { cart: Cart; reloadCart?: boolean } & HasOnError<string> & HasOnSuccess<string>;

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartParameter, UpdateCartApiParameter, CartResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cart: props.parameter.cart,
    };
};

export const UpdateCart: HandlerType = async props => {
    const result = await updateCartWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const LoadCart: HandlerType = props => {
    if (props.parameter.reloadCart) {
        if (props.parameter.cart.id !== "current") {
            props.dispatch(ootbLoadCartHandler({ cartId: props.parameter.cart.id }));
        } else {
            props.dispatch(loadCurrentCart());
        }
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult.cart.id);
};

export const chain = [PopulateApiParameter, UpdateCart, LoadCart, ExecuteOnSuccessCallback];

const updateCart = createHandlerChainRunner(chain, "UpdateCart");
export default updateCart;
